// As CÓPIAS do nome do lead (`leadNome`) em agendamentos e tarefas — puro.
//
// ★★ Nome do lead (28/out/2026, decisão do dono): a Agenda (caixinha, detalhe, busca) e os Próximos
// contatos leem `leadNome`, gravado quando a consulta ou a tarefa nasce. Renomear o lead não tocava
// nessas cópias, e a tela seguia com o nome antigo (medido: 218 agendamentos e 11 tarefas abertas, ver
// `docs/medicao-nome-lead.md`). Agora o `renomearLead` reescreve as cópias junto.
//
// ★ Por que copiar em vez de ler o lead na tela: a recepção NÃO lê `leads` (rules), e para ela a cópia
// é a única fonte do nome na Agenda.

/** Limite de escritas de um `writeBatch` do Firestore. */
export const LIMITE_LOTE = 500;

const limpo = (v) => String(v ?? '').trim();

/**
 * Os documentos cuja cópia difere do nome novo. `docs` são snapshots (`{ data() }`) ou objetos simples.
 * A comparação ignora espaços nas pontas: reescrever "Ana " para "Ana" não muda nada na tela.
 */
export function copiasDesatualizadas(docs, nome) {
  const alvo = limpo(nome);
  return (docs ?? []).filter((d) => {
    const dados = typeof d?.data === 'function' ? d.data() : d;
    return limpo(dados?.leadNome) !== alvo;
  });
}

/**
 * Reparte as cópias em lotes. O PRIMEIRO lote leva também as `fixas` escritas do nome (lead, conversas,
 * nota) — é ele que mantém o "tudo ou nada" do nome. As cópias que não couberem vão em lotes seguintes:
 * reescrever uma cópia é idempotente, então um lote seguinte que falhe deixa só cópia velha, nunca um
 * lead com dois nomes.
 *
 * Medido em produção (28/out): o maior lote de um lead é 22 escritas (13 agendamentos, 8 tarefas, 1
 * conversa, lead e nota) — longe de 500. A divisão existe para o lead que um dia passar disso.
 */
export function dividirEmLotes(fixas, copias, limite = LIMITE_LOTE) {
  if (!Number.isInteger(fixas) || fixas < 1) throw new Error('dividirEmLotes: fixas inválidas');
  if (fixas > limite) throw new Error(`dividirEmLotes: ${fixas} escritas fixas não cabem num lote de ${limite}`);
  const lista = [...(copias ?? [])];
  const lotes = [lista.splice(0, limite - fixas)];
  while (lista.length) lotes.push(lista.splice(0, limite));
  return lotes;
}
